var cartForm = document.getElementById('cart-form');

if (cartForm) {
    var request = new XMLHttpRequest();

    request.onreadystatechange = function() {
        if(request.readyState === 4) {
            if(request.status >= 200 || request.status <= 299) {
                location.reload();
            } else {
               //TODO: show error ??
            }
        }
    };

    var cartFormRemoveItems = cartForm.getElementsByClassName('cart-form__remove-button');

    for (var i = 0; i < cartFormRemoveItems.length; i++) {
        cartFormRemoveItems[i].addEventListener('click', onCartItemRemove);
    }
}

function onCartItemRemove(e) {
    e.preventDefault();

    request.open('DELETE', this.getAttribute('data-action'));
    request.setRequestHeader('Content-Type', 'application/json');
    request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    request.send(JSON.stringify({
        _csrf_token: this.getAttribute('data-csrf-token')
    }));
}
